import { useContext } from 'react';
import { BIMContext } from 'providers/bim-provider';
import { ContentWrapper, Textbox, SelectMenu, Button, Checkbox } from 'components/generic';
import { colName, csvArray, csvJSON, xlsxConvertorFunc, getValuesById } from 'utils';
import { UploadTable } from '..';
import { map } from 'lodash';
import { useSelector } from 'react-redux';
import './style.scss';

const UploadData = () => {
	const context = useContext(BIMContext);
	const referenceData = useSelector(state => state.referenceData)?.data;
	const { createObj, setCreateObj, fileData, setFileData, dockerState } = context;

	// read file  form input
	const fileReadHandler = e => {
		const obj = e?.target?.files[0];
		if (obj) {
			setCreateObj(prevState => ({ ...prevState, bfm_fileName: obj?.name, bfm_fieldDelimiter: ',' }));
			const reader = new FileReader();
			reader.readAsBinaryString(obj);
			reader.onload = () => {
				setFileData(reader.result);
			};
		}
	};

	// data format
	const dateType = referenceData?.find(el => el?.key === 'rd_dateType')?.value;

	// convert the binary to JSON
	const fileCovertorfunc = async () => {
		let obj;
		let trailFormulaData;
		switch (createObj?.bfm_fileType) {
			case 'excel':
				obj = xlsxConvertorFunc(fileData);
				trailFormulaData = obj[0];
				break;
			case 'delimiter_separated':
				obj = csvJSON(fileData, createObj?.bfm_fieldDelimiter);
				trailFormulaData = csvArray(fileData)[0];
				break;
			default:
				return false;
		}
		context.setTrailFormulaData(trailFormulaData);
		context.setCreateObj(prevState => ({ ...prevState, bfm_fileObj: JSON.stringify(trailFormulaData) }));
		createMappingObj(createObj?.bfm_fileType === 'excel' ? Object.keys(obj[0]) : obj);
	};

	// mapping function for the source data
	const createMappingObj = obj => {
		const list = map(obj, (el, i) => ({
			id: i,
			bfm_serialNumber: `#${i + 1}`,
			bfm_fieldPosition: createObj?.bfm_fileType === 'excel' ? colName(i) : i + 1,
			bfm_columnHeading: el?.toString()?.replace(/[`\[\];\'\"\/\\\?]/g, ''),
			bfm_desField: '',
			bfm_formula: '',
			bfm_refLink: '',
			bfm_linkedSNo: '',
			bfm_updateMethod: '',
			bfm_fields: '',
			bfm_factValues: ''
		}));
		setCreateObj(prevState => ({ ...prevState, bfm_uploadDetails: list }));
	};

	// common data handler for all basic input fields
	const dataHandler = (e, key) => {
		setCreateObj(prevState => ({ ...prevState, [key]: e }));
	};

	return (
		<>
			<ContentWrapper shadow>
				<div className='row'>
					<div className='col-4 upload__file'>
						<label>
							Sample File <sup>*</sup>
						</label>
						<div className='upload__fileinput'>
							<input type='file' accept='.xlsx, .xls,.csv,.txt' disabled={dockerState === 'view'} onChange={fileReadHandler} />
							<span className='upload__filename'>{createObj?.bfm_fileName?.slice(0, 20) || 'No file chosen'}</span>
						</div>
					</div>

					<div className='col-4'>
						<Textbox placeholder='Eg:,' infoContent='Enter Field Delimiter Char' value={createObj.bfm_fieldDelimiter} onChange={e => setCreateObj(prevState => ({ ...prevState, bfm_fieldDelimiter: e.target.value }))} label='Field Delimiter Char' disabled />
					</div>
				</div>

				<div className='row'>
					<div className='col-4'>
						<SelectMenu
							label='Date Format'
							infoContent='Select Field Delimiter Char'
							value={getValuesById(dateType, createObj?.bfm_dateFormat)}
							mandatory
							placeholder='Select'
							disabled={dockerState === 'view'}
							menuOptions={dateType}
							onChange={e => setCreateObj(prevState => ({ ...prevState, bfm_dateFormat: e }))}
						/>
					</div>
				</div>

				<Button label='Load Source Structure' transparent handleOnSubmit={fileCovertorfunc} disabled={dockerState === 'view' || !createObj?.bfm_fileName} />
				<div className='upload__checkbox'>
					<Checkbox value='heading' last content='Skip heading line' checked={createObj?.bfm_skipHeader === 'Y'} onClick={e => dataHandler(e?.target?.checked ? 'Y' : 'N', 'bfm_skipHeader')} />
					<Checkbox value='footerline' last content='Skip footer line' checked={createObj?.bfm_skipFooter === 'Y'} onClick={e => dataHandler(e?.target?.checked ? 'Y' : 'N', 'bfm_skipFooter')} />
				</div>
			</ContentWrapper>

			{createObj?.bfm_uploadDetails?.length > 0 && <UploadTable />}
		</>
	);
};

export default UploadData;
